import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('pages.RequestFormPage.XeroAmaxPayBatchPaymentForm', {
    saveAndSubmitRequestSuccess: 'The request is submitted for approval.',
});
